<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!-- 점검정보 -->
    <div>
      <vs-row class="my-4">
        <vs-col>
          <h5><i class="dot"></i>점검정보</h5>
        </vs-col>
      </vs-row>
      <div
        class="grid flex-wrap"
        style="grid-template-columns: 1fr 1fr 1fr; column-gap: 1.5rem"
      >
        <vs-row
          class="mb-4"
          style="display: grid; grid-template-columns: 128px 1fr"
          vs-align="center"
        >
          <vs-col>담당부서</vs-col>
          <vs-col>
            <span v-if="isPrint" class="print-input">
              {{ form.inputA_1 }}
            </span>
            <company-selector
              v-else
              v-model="form.inputA_0"
              :company-name="form.inputA_1"
              @select="targetCompany"
              :readonly="board.readonly"
              :field-id="form.stdInfo.field_id"
              class="w-full flex-1"
            />
          </vs-col>
        </vs-row>
        <vs-row
          class="mb-4"
          style="display: grid; grid-template-columns: 128px 1fr"
          vs-align="center"
        >
          <vs-col>점검자명</vs-col>
          <vs-col>
            <span v-if="isPrint" class="print-input">
              {{ form.inputA_2 }}
            </span>
            <ml-input
              v-else
              :readonly="board.readonly"
              class="w-full flex-1"
              placeholder="입력필드"
              v-model="form.inputA_2"
            />
          </vs-col>
        </vs-row>
        <vs-row
          class="mb-4"
          style="display: grid; grid-template-columns: 128px 1fr"
          vs-align="center"
        >
          <vs-col>점검일</vs-col>
          <vs-col>
            <span v-if="isPrint" class="print-input">
              {{ form.inputA_3 }}
            </span>
            <date-selector
              v-else
              :readonly="board.readonly"
              placeholder="날짜선택"
              class="w-full flex-1"
              v-model="form.inputA_3"
            />
          </vs-col>
        </vs-row>
      </div>
    </div>

    <!-- 업무 수행 여부 -->
    <div>
      <vs-row class="my-4">
        <vs-col class="flex items-center">
          <h5><i class="dot"></i>업무 수행 여부</h5>
          <div class="flex items-center cursor-pointer" @click="openPopup">
            <feather-icon
              icon="AlertCircleIcon"
              class="ml-6 mr-1"
              style="cursor: pointer; width: 18px; color: #7e72f2"
            />
            <span style="color: #7e72f2"> 이행사항 점검 시 작성요령 </span>
          </div>
        </vs-col>
      </vs-row>
      <table-inspect
        class="mt-5"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="false"
        :is-note="true"
        table-header-yes="양호"
        table-header-no="미흡"
        table-header-na="해당없음"
        table-header-note="개선요망 사항"
        footer="※ (중처법=중대재해처벌 등에 관한 법률. 산안법=산업안전보건법)"
        v-model="form.inspectList"
      />
    </div>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    />

    <!-- 이행사항 점검 시 작성요령 팝업 -->
    <vs-popup
      id="popAlert"
      title="이행사항 점검 시 작성요령"
      :active.sync="showPopup"
    >
      <table id="PopupTable">
        <tr>
          <th>증빙자료 첨부</th>
        </tr>
        <tr>
          <td class="p-3 font-bold">반드시 증빙자료 첨부 필요</td>
        </tr>
        <tr>
          <td class="p-3">
            <b>증빙자료 예시</b>
            <ul>
              <li>
                연번 1 : 업무분장 등 안전보건업무를 관리하는 업무담당자 및
                총괄책임자등을 알 수 있는 자료
              </li>
              <li>
                연번 2 : 안전보건 관련 예산(안전점검 및 관리, 안전용품 및
                안전교육 예산 등)
              </li>
              <li>
                연번 3 : 정기점검 및 수시점검 등 안전관리계획, 시설관리 계획 및
                점검결과 자료
              </li>
              <li>연번 4 : 연번1~4번까지의 내용이 포함된 종합계획</li>
              <li>
                연번 5 : 유해위험요인 처리 절차, 중대시민재해 발생 대응
                매뉴얼(담당자 표시된 것), 재해발생시 보고절차
              </li>
              <li>
                연번 6 : 도급용역위탁 시 평가기준 및 절차 마련, 안전보건서약서
                서류철 사진 등
              </li>
              <li>
                연번 7 : 『중대시민재해 이행사항 점검표』 제출로 갈음.<br />
                * 자체점검 결과가 ‘보통’인 사항은 비고란에 미이행사항 및 개선
                조치 계획 등을 기재, ‘미흡’인 사항에 대해서는 보완 조치 계획,
                재점검 계획 등을 별도로 첨부하여 제출
              </li>
              <li>
                연번 8 : 교육일지 및 교육 이수증, 미이수 사항 발견시 개선조치
                계획 등
              </li>
            </ul>
          </td>
        </tr>
      </table>
    </vs-popup>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspect from "@/components/TableInspectNo";
import DateSelector from "@/components/selector/DateSelector";
import CompanySelector from "@/components/selector/CompanySelector";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    TableInspect,
    DateSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      showPopup: false,
      form: {
        stdInfo: {},
        fileList: [],
        inspectList: [
          {
            label: "필요한 안전인력 확보 [중처법 제10조제1호]",
            chlid: [
              {
                label: "시설 안전보건 조치 업무 담당",
                is_checked: "",
              },
              {
                label: "시설설비 유지보수 업무 관리",
                is_checked: "",
              },
            ],
          },
          {
            label: "필요한 안전예산 편성·집행 [중처법 제10조제2호]",
            chlid: [
              {
                label: "안전보건 관련 인건비",
                is_checked: "",
              },
              {
                label: "시설장비 안전 확보 유지관리비",
                is_checked: "",
              },
              {
                label: "안전점검비",
                is_checked: "",
              },
              {
                label: "기타비용",
                is_checked: "",
              },
            ],
          },
          {
            label: "안전점검 계획 수립·시행 [중처법 제10조제3호]",
            chlid: [
              {
                label: "정기안전점검",
                is_checked: "",
              },
              {
                label: "정밀안전점검",
                is_checked: "",
              },
              {
                label: "정밀안전진단",
                is_checked: "",
              },
            ],
          },
          {
            label: "안전계획 수립·시행 [중처법 제10조제4호]",
            chlid: [
              {
                label: "인력확보",
                is_checked: "",
              },
              {
                label: "점검계획 수립 및 이행여부",
                is_checked: "",
              },
              {
                label: "유지관리 계획 및 시행",
                is_checked: "",
              },
            ],
          },
          {
            label: "재해예방 업무처리 절차 마련·이행 [중처법 제10조제7호]",
            chlid: [
              {
                label: "유해위협요인 점검",
                is_checked: "",
              },
              {
                label: "유해위협요인 발견 시 조치",
                is_checked: "",
              },
              {
                label: "재해 발생 시 대응 절차 및 매뉴얼",
                is_checked: "",
              },
              {
                label: "비상대피훈련 계획 등",
                is_checked: "",
              },
            ],
          },
          {
            label: "도급용역위탁 기준과 절차 마련·이행 [중처법 제10조제8호]",
            chlid: [
              {
                label: "도급용역위탁 시 평가기준 및 절차 마련",
                is_checked: "",
              },
            ],
          },
          {
            label:
              "안전보건 관계 법령 의무이행 점검 [중처법 제11조제2항제1호, 2호]",
            chlid: [
              {
                label: "의무이행사항 점검",
                is_checked: "",
              },
              {
                label: "미이행 사항 발견시 조치",
                is_checked: "",
              },
            ],
          },
          {
            label:
              "안전관리자/종사자교육 시행 점검 [중처법 제11조제2항제3호, 4호]",
            chlid: [
              {
                label: "교육 이수 점검",
                is_checked: "",
              },
              {
                label: "미이수 사항 발견시 조치",
                is_checked: "",
              },
            ],
          },
        ],
        inputA_0: "",
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
      },
    };
  },
  methods: {
    openPopup() {
      this.showPopup = true;
    },
    targetCompany(value) {
      this.form.inputA_1 = value.com_name;
    },
  },
};
</script>

<style scoped lang="scss">
#PopupTable {
  width: 100%;
  border-collapse: collapse;

  &,
  tr,
  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 700;
    font-size: 16px;
    line-height: 23px;
    text-align: center;
    background: #f9f9f9;
    padding: 10px 0;
  }

  li {
    margin-left: 16px;
    &::marker {
      content: " · ";
      font-size: 1.2em;
    }
  }
}
</style>
